// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
        .title {
            margin-top: 30px;
            margin-left: 20px;
            margin-bottom: 30px;
        }

        .datetime-card {
            height: 65%;
            width: 60%;
        }

        .datetime {
            display: flex;
            justify-content: center;
        }

        .button-salva {
            display: flex;
            justify-content: flex-end;
        }
    `, "",{"version":3,"sources":["webpack://./src/app/storico-rilevazioni/report/report.component.ts"],"names":[],"mappings":";QACQ;YACI,gBAAgB;YAChB,iBAAiB;YACjB,mBAAmB;QACvB;;QAEA;YACI,WAAW;YACX,UAAU;QACd;;QAEA;YACI,aAAa;YACb,uBAAuB;QAC3B;;QAEA;YACI,aAAa;YACb,yBAAyB;QAC7B","sourcesContent":["\n        .title {\n            margin-top: 30px;\n            margin-left: 20px;\n            margin-bottom: 30px;\n        }\n\n        .datetime-card {\n            height: 65%;\n            width: 60%;\n        }\n\n        .datetime {\n            display: flex;\n            justify-content: center;\n        }\n\n        .button-salva {\n            display: flex;\n            justify-content: flex-end;\n        }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
